import { App } from '@capacitor/app'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

interface IProps {
  hosts: string[]
}

export const UniversalLinkHandler: React.FC<IProps> = ({ hosts }) => {
  const history = useHistory()

  useEffect(() => {
    let listener: { remove: () => Promise<void> } | undefined

    const normalizedHosts = hosts.map((host) => host.toLowerCase())

    const handleUrl = (url: string) => {
      try {
        const parsed = new URL(url)

        if (!normalizedHosts.includes(parsed.hostname.toLowerCase())) return

        const route = `${parsed.pathname}${parsed.search}${parsed.hash}`

        console.log('Universal link route:', route)

        history.push(route)
      } catch (err) {
        console.error('Failed to handle universal link', err)
      }
    }

    App.getLaunchUrl().then((result) => {
      if (result?.url) {
        console.log('Launch URL:', result.url)
        handleUrl(result.url)
      }
    })

    const setup = async () => {
      listener = await App.addListener('appUrlOpen', (event) => {
        console.log('Universal link opened:', event)

        if (event?.url) {
          handleUrl(event.url)
        }
      })
    }

    setup()

    return () => {
      listener?.remove()
    }
  }, [history, hosts])

  return null
}
